<template>
  <div class="container-fluid">
    <!-- Filtro por estado -->
    <SelectDropdown
      v-model="filtroEstado"
      class="text-start mb-3"
      :options="['Disponibles', 'Vendidos']"
    />

    <div class="row">
      <!-- CATEGORÍAS EN MÓVIL: DROPDOWN -->
      <div class="col-12 d-block d-md-none">
        <div class="m-2">
          <div class="dropdown w-100">
            <button
              class="btn btn-light border w-100 d-flex justify-content-between align-items-center"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span>Categorías</span>
              <i class="bi bi-chevron-down"></i>
            </button>

            <ul class="dropdown-menu w-100 p-3">
              <li
                v-for="categoria in categorias"
                :key="'mobile-' + categoria.id"
                class="form-check mb-2"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="categoriesSelected"
                  :value="categoria.id"
                  :id="'cat-mobile-' + categoria.id"
                />
                <label
                  class="form-check-label"
                  :for="'cat-mobile-' + categoria.id"
                >
                  {{ categoria.name }}
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- CATEGORÍAS EN ESCRITORIO: SIDEBAR -->
      <div class="col-md-2 d-none d-md-block">
        <div class="m-2 p-4 categorias">
          <h5 class="mb-3 text-center">Categorías</h5>
          <hr />
          <div
            v-for="categoria in categorias"
            :key="'desktop-' + categoria.id"
            class="form-check ms-3 mb-2"
          >
            <input
              class="form-check-input"
              v-model="categoriesSelected"
              type="checkbox"
              :value="categoria.id"
              :id="'cat-desktop-' + categoria.id"
            />
            <label
              class="form-check-label"
              :for="'cat-desktop-' + categoria.id"
            >
              {{ categoria.name }}
            </label>
          </div>
          <hr />
        </div>
      </div>

      <!-- LISTA DE PRODUCTOS -->
      <div class="col-12 col-md-8 text-center">
        <div class="products">
          <ProductCardHome
            v-for="producto in productos"
            :key="producto.id"
            class="mb-5"
            :producto="producto"
          />
        </div>
      </div>

      <!-- Columna vacía en escritorio para centrar -->
      <div class="d-none d-md-block col-md-2"></div>
    </div>
  </div>
</template>

<script>
import ProductCardHome from '@/components/products/ProductCardHome.vue'
import SelectDropdown from '@/components/products/SelectDropdown.vue'

export default {
  name: 'HomeApp',
  components: {
    ProductCardHome,
    SelectDropdown,
  },
  data() {
    return {
      productos: [],
      categorias: [],
      filtroEstado: 'Disponibles',
      readyCategorias: false,
      categoriesSelected: [],
    }
  },
  beforeMount() {
    this.filtrarProductos(this.filtroEstado)
    this.getCategorias()
  },
  methods: {
    filtrarProductos(filtroEstado, filtroCategorias = []) {
      let estados = []

      switch (filtroEstado) {
        case 'Disponibles':
          estados = ['disponible', 'llega_pronto']
          break
        case 'Vendidos':
          estados = ['vendido']
          break
        default:
          estados = ['disponible', 'llega_pronto']
      }

      let url = `${process.env.VUE_APP_API_URL}/api/product/products/?estado=${encodeURIComponent(estados.join(','))}`

      if (filtroCategorias.length > 0) {
        const categoriasParam = filtroCategorias.join(',')
        url += `&categories=${encodeURIComponent(categoriasParam)}`
      }

      const requestOptions = {
        method: 'GET',
        redirect: 'follow',
      }

      fetch(url, requestOptions)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then((data) => {
          console.log('Productos filtrados:', data)
          this.productos = data
        })
        .catch((error) => console.error('Error al obtener productos:', error))
    },

    getCategorias() {
      const requestOptions = {
        method: 'GET',
        redirect: 'follow',
      }

      fetch(`${process.env.VUE_APP_API_URL}/api/product/categories/`, requestOptions)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then((data) => {
          console.log('Categorias:', data)
          this.categorias = data
          this.readyCategorias = true
        })
        .catch((error) => console.error('Error al obtener categorías:', error))
    },
  },
  watch: {
    filtroEstado(newValue) {
      this.filtrarProductos(newValue, this.categoriesSelected)
    },
    categoriesSelected(newValue) {
      this.filtrarProductos(this.filtroEstado, newValue)
    },
  },
}
</script>

<style scoped>
.overlay {
  background-color: rgb(0, 0, 0);
}

.products {
  padding: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  align-content: stretch;
}

.text-justify {
  text-align: justify;
}

.categorias {
  margin-top: 25px !important;
  background-color: rgb(229, 229, 229);
  width: 100%;
  border-radius: 8px;
  padding: 10px;
  min-height: 450px;
}
</style>